"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerGlobal = void 0;
const logger_core_1 = require("./logger-core");
const logger_http_writer_1 = require("./logger-http-writer");
Object.defineProperty(exports, "LoggerGlobal", { enumerable: true, get: function () { return logger_http_writer_1.LoggerGlobal; } });
exports.default = logger_core_1.LoggerCore;
//# sourceMappingURL=source.js.map